export const seoHtml = `
  <h1>Мобильное приложение БК Зенит для Android и iOS</h1>

  <p>Мобильное приложение БК Зенит доступно для смартфонов и планшетов на Android и iOS. В приложении работает весь
    функционал сайта: ставки в линии и лайве, пополнение счёта, вывод выигрышей, бонусы и быстрые игры. Скачивание и
    установка приложения – бесплатны на всех платформах.</p>

  <h2>Где скачать приложение БК Зенит</h2>

  <table style="margin-bottom:16px;">
    <thead>
      <tr>
        <th>Платформа</th>
        <th>Способ установки</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Android</td>
        <td>APK-файл с официального сайта zenit.win</td>
      </tr>
      <tr>
        <td>Android</td>
        <td>RuStore</td>
      </tr>
      <tr>
        <td>Android</td>
        <td>AppGallery (Huawei)</td>
      </tr>
      <tr>
        <td>iOS</td>
        <td>App Store</td>
      </tr>
    </tbody>
  </table>

  <p>Для Android рекомендуется скачивать APK-файл с официального сайта – так всегда доступна актуальная версия приложения.
  </p>

  <h2>Как установить приложение на Android</h2>

  <ol>
    <li>Перейдите на zenit.win с телефона и нажмите кнопку скачивания APK.</li>
    <li>Разрешите установку из неизвестных источников в настройках телефона (Настройки → Безопасность → Установка из
      неизвестных источников).</li>
    <li>Откройте скачанный файл и нажмите «Установить».</li>
    <li>После установки войдите в аккаунт или зарегистрируйтесь.</li>
  </ol>

  <h2>Как установить приложение на iOS</h2>

  <p>Найдите «БК Зенит» в App Store или перейдите по ссылке с официального сайта. Нажмите «Загрузить» и дождитесь
    установки.</p>

  <h2>Возможности приложения</h2>

  <table class="align-right">
    <thead>
      <tr>
        <th>Функция</th>
        <th>Наличие</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Ставки в линии и лайве</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
      <tr>
        <td>Видеотрансляции и трекер</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
      <tr>
        <td>Быстрые игры 24/7</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
      <tr>
        <td>Пополнение и вывод</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
      <tr>
        <td>Бонусы и программа лояльности</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
      <tr>
        <td>Кэшаут</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
      <tr>
        <td>Push-уведомления</td>
        <td>
          <svg style="display:block;margin-left:auto;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.681 4.13333C17.0779 4.49246 17.1085 5.10538 16.7494 5.50231L8.56484 14.5484C8.38674 14.7453 8.1357 14.8604 7.87033 14.8671C7.60496 14.8737 7.34848 14.7712 7.16078 14.5835L3.28388 10.7066C2.90537 10.3281 2.90537 9.71441 3.28388 9.3359C3.66239 8.95739 4.27606 8.95739 4.65457 9.3359L7.811 12.4923L15.312 4.20178C15.6711 3.80484 16.284 3.7742 16.681 4.13333Z" fill="#313131"/>
          </svg>
        </td>
      </tr>
    </tbody>
  </table>

  <h2>Часто задаваемые вопросы</h2>

  <details open style="margin-bottom:16px;">
    <summary>
      <h3 style="display:inline;margin:0;">Как скачать приложение БК Зенит на Android?</h3>
    </summary>
    <p style="margin-top:8px;">Скачайте APK-файл с официального сайта zenit.win, разрешите установку из неизвестных
      источников в настройках телефона и установите приложение. Также доступно в RuStore и AppGallery.</p>
  </details>

  <details style="margin-bottom:16px;">
    <summary>
      <h3 style="display:inline;margin:0;">Есть ли приложение БК Зенит для iPhone?</h3>
    </summary>
    <p style="margin-top:8px;">Да, приложение доступно в App Store. Найдите «БК Зенит» или перейдите по ссылке с
      официального сайта.</p>
  </details>

  <details style="margin-bottom:16px;">
    <summary>
      <h3 style="display:inline;margin:0;">Бесплатно ли приложение БК Зенит?</h3>
    </summary>
    <p style="margin-top:8px;">Да, скачивание и установка бесплатны на всех платформах.</p>
  </details>

  <details style="margin-bottom:16px;">
    <summary>
      <h3 style="display:inline;margin:0;">Чем приложение отличается от мобильной версии сайта?</h3>
    </summary>
    <p style="margin-top:8px;">Приложение работает быстрее, расходует меньше трафика и позволяет получать
      push-уведомления о расчёте ставок и новых акциях. Весь функционал сайта доступен в приложении.</p>
  </details>

  <details>
    <summary>
      <h3 style="display:inline;margin:0;">Какая минимальная сумма ставки и депозита в приложении?</h3>
    </summary>
    <p style="margin-top:8px;">Минимальная ставка в приложении – от 20 ₽. Пополнить счёт можно любым удобным способом,
      включая СБП, без комиссии.</p>
  </details>
`;
